module.exports = "//static.hsappstatic.net/ContentComponents/static-2.71999/img/landing-page-zero.png"